import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from './index.css';
import ColumnIntro from '../../../components/columnIntro';
import { NewsStream } from '@ifeng-fe/news-stream';
import '@ifeng-fe/news-stream/lib/NewsStream/style/news-stream-global.css';
import ShanklistComponents from '../../originalComponents/index';
import Chip from 'Chip';

const getType = function getType(type) {
    const types = {
        recommendFragment: 'recommend',
        staticFragment: 'static',
        structuredFragment: 'struct',
    };

    return types[type] ? types[type] : type;
};

class AsideHtml extends PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    render() {
        const { content } = this.props;

        return <div dangerouslySetInnerHTML={{ __html: content }} />;
    }
}

class Content extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    // 渲染
    componentsView(mainData) {
        const { noAd } = this.props.content;

        return mainData.map((item, index) => {
            const { chip, data, component, componentOptions } = item;

            if (!(component in ShanklistComponents)) return null;

            if (chip.user && chip.user !== '') {
                // 重写编辑碎片的配置
                if (componentOptions.key) chip.id = componentOptions.key;
                if (componentOptions.type) chip.type = getType(componentOptions.type);

                return (
                    <Chip key={index} content={data} {...chip}>
                        {React.createElement(ShanklistComponents[component], { componentOptions, noAd })}
                    </Chip>
                );
            } else {
                return React.createElement(ShanklistComponents[component], {
                    key: index,
                    componentOptions,
                    content: data,
                    noAd,
                });
            }
        });
    }

    render() {
        const { content } = this.props;
        const { columnIntroData, newsstream, columnId, isEnd, mainData, originalAside } = content;

        /**
         * 组件分发数据
         */
        return (
            <div className={style.wrap_1000w}>
                <div className={style.left_640w}>
                    {/* mainData */}
                    {/* 原创列表页：信息流推荐位 */}
                    {this.componentsView(mainData)}
                    <NewsStream content={newsstream} columnId={columnId} isEnd={isEnd} />
                </div>
                <div className={style.right_300w}>
                    <ColumnIntro content={columnIntroData} />
                    {originalAside ? (
                        <Chip
                            id={originalAside.id}
                            type="static"
                            title="右侧"
                            groupName="右侧"
                            content={originalAside.data}>
                            <AsideHtml />
                        </Chip>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default Content;
